import { ButtonRounded } from '../Buttons/ButtonRounded';

/**
 * A centred, frosted dark notice over the page — first built inline on the
 * guest's exchange page for a timed-out connection ("Please scan the QR
 * again!"), now shared. With an action it carries one white rounded button
 * (guest-session-loss: "Lost connection for a moment" + "Try again", Mark
 * 2026-10-07). Fixed and centred; only the card takes taps.
 *
 * @param {object} p
 * @param {string} p.title
 * @param {React.ReactNode} [p.line] - the softer line under the title
 * @param {string} [p.actionLabel]
 * @param {Function} [p.onAction]
 * @param {boolean} [p.busy] - the action is running
 */
const NoticeCard = ({ title, line, actionLabel, onAction, busy = false }) => (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      pointerEvents: 'none',
    }}
  >
    <div
      role="alert"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderRadius: '16px',
        padding: '20px 28px',
        maxWidth: '300px',
        textAlign: 'center',
        pointerEvents: 'auto',
      }}
    >
      <p
        style={{
          fontSize: '16px',
          fontWeight: 600,
          color: '#fff',
          margin: '0 0 4px 0',
          lineHeight: 1.4,
        }}
      >
        {title}
      </p>
      {line ? (
        <p
          style={{
            fontSize: '15px',
            fontWeight: 400,
            color: 'rgba(255, 255, 255, 0.8)',
            margin: 0,
            lineHeight: 1.4,
          }}
        >
          {line}
        </p>
      ) : null}
      {actionLabel ? (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '14px' }}>
          <ButtonRounded
            text={actionLabel}
            onClick={onAction}
            size="compact"
            variant="secondary"
            disabled={busy}
            style={{ backgroundColor: '#fff', color: '#000', fontWeight: 600 }}
          />
        </div>
      ) : null}
    </div>
  </div>
);

export default NoticeCard;
